import React, { memo } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import cls from './SelectColor.module.css';
import { Color, useSelectColor } from './useSelectColor';
import { useClickOutside } from '../../hooks';
import { Icon } from '../Icon';

interface SelectColorProps {
    classes?: string;
    placeholder?: string;
    filteredData: { colors: string[] };
    onFilteredData(name: 'colors', value: string[]): void;
}

export const SelectColor = memo(({ classes, onFilteredData, filteredData }: SelectColorProps) => {
    const {
        isOpen,
        changeOpen,
        changeActiveColor,
        activeColor,
        isSelected,
        selectedColor,
        setIsOpen,
        resetColors,
    } = useSelectColor(onFilteredData, filteredData);
    const { rootRef } = useClickOutside({ isOpen, setIsOpen });

    const { t } = useTranslation();

    return (
        <div
            className={classNames(cls.SelectColorWrapper, [classes], {
                [cls.active]: isOpen,
                [cls.selectedColors]: isSelected,
            })}
            onClick={changeOpen}
            ref={rootRef}
        >
            <div className={cls.iconWrapper}>
                <Icon iconName="taskColor" fill={isSelected ? '#1094F7' : undefined} />
            </div>
            <div className={cls.SelectColorsWrapper}>
                {selectedColor.length ? (
                    selectedColor.map((color) => (
                        <div key={color} className={classNames(cls.SelectColor, cls[color])} />
                    ))
                ) : (
                    <div className={cls.placeholder}>{t('SelectColor.return.placeholder')}</div>
                )}
            </div>
            <div
                onClick={(event) => event.stopPropagation()}
                className={classNames(cls.dropdown, {
                    [cls.open]: isOpen,
                })}
            >
                <div className={cls.colors}>
                    {Object.values(Color).map((color) => (
                        <div
                            key={color}
                            onClick={() => changeActiveColor(color)}
                            className={classNames(cls.colorWrapper, {
                                [cls.active]: activeColor[color],
                            })}
                        >
                            <div className={classNames(cls.color, cls[color])} />
                        </div>
                    ))}
                </div>
            </div>
            {isSelected ? (
                <button onClick={resetColors} className={cls.resetIcon}>
                    <Icon iconName="resetInput" />
                </button>
            ) : (
                <div
                    className={classNames(cls.arrow, {
                        [cls.openArrow]: isOpen,
                    })}
                >
                    <Icon iconName="selectArrow" />
                </div>
            )}
        </div>
    );
});
